if (!customElements.get('variant-selector-layer-mobile')) {
  customElements.define(
    'variant-selector-layer-mobile',
    class VariantSelectorLayerMobile extends HTMLElement {
      constructor() {
        super();
        this.currentProduct = null;
      }

      connectedCallback() {
        this.overlay = this.querySelector('.variant-selector-layer-mobile__overlay');
        this.content = this.querySelector('.variant-selector-layer-mobile__content');
        this.closeButton = this.querySelector('.variant-selector-layer-mobile__close');
        this.variantsContainer = this.querySelector('.variant-selector-layer-mobile__items');
        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.querySelector('.variant-selector-layer-mobile__submit-text');
        this.variantIdInput = this.querySelector('[name="id"]');

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.close.bind(this));
        }

        if (this.overlay) {
          this.overlay.addEventListener('click', this.close.bind(this));
        }

        if (this.form) {
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }

        document.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE' && this.isOpen()) {
            this.close();
          }
        });
      }

      isOpen() {
        return this.classList.contains('active');
      }

      open(productData) {
        this.currentProduct = productData;
        this.updateContent(productData);
        this.classList.add('active');
        document.body.classList.add('overflow-hidden');
      }

      close() {
        this.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      }

      updateContent(productData) {
        // Clear and update variants
        if (this.variantsContainer) {
          this.variantsContainer.innerHTML = '';

          productData.variants.forEach((variant, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className =
              'variant-option' +
              (variant.available ? '' : ' variant-option--soldout') +
              (index === 0 ? ' selected' : '');
            button.dataset.variantId = variant.id;
            button.dataset.available = variant.available;
            button.dataset.variantPrice = variant.price;

            if (!variant.available) {
              button.disabled = true;
            }

            const titleSpan = document.createElement('span');
            titleSpan.className = 'variant-option__title text-body';
            titleSpan.textContent = variant.title;
            button.appendChild(titleSpan);

            if (!variant.available) {
              const availSpan = document.createElement('span');
              availSpan.className = 'variant-option__availability';
              availSpan.innerHTML = '&nbsp;-&nbsp;' + (window.variantStrings?.soldOut || 'Sold out');
              button.appendChild(availSpan);
            }

            button.addEventListener('click', this.onVariantSelect.bind(this));
            this.variantsContainer.appendChild(button);
          });
        }

        // Update form
        if (productData.variants && productData.variants.length > 0) {
          const firstVariant = productData.variants[0];
          this.variantIdInput.value = firstVariant.id;

          // Update submit button text
          if (this.submitButtonText) {
            const addToCartText = window.variantStrings?.addToCart || 'Ajouter au panier';
            while (this.submitButtonText.firstChild) {
              this.submitButtonText.removeChild(this.submitButtonText.firstChild);
            }
            this.submitButtonText.appendChild(document.createTextNode(`${addToCartText} - ${firstVariant.price}`));
          }
        }

        // Update form action if needed
        if (this.form && productData.url) {
          this.form.dataset.productUrl = productData.url;
        }
      }

      onVariantSelect(event) {
        event.preventDefault();
        const button = event.currentTarget;
        const variantId = button.dataset.variantId;
        const isAvailable = button.dataset.available === 'true';
        const variantPrice = button.dataset.variantPrice;

        if (!isAvailable) return;

        // Update selected state
        const allButtons = this.variantsContainer.querySelectorAll('.variant-option');
        allButtons.forEach((btn) => btn.classList.remove('selected'));
        button.classList.add('selected');

        // Update hidden input
        this.variantIdInput.value = variantId;
        this.variantIdInput.disabled = false;

        // Update submit button text with price
        if (this.submitButtonText && variantPrice) {
          const addToCartText = window.variantStrings?.addToCart || 'Ajouter au panier';
          while (this.submitButtonText.firstChild) {
            this.submitButtonText.removeChild(this.submitButtonText.firstChild);
          }
          this.submitButtonText.appendChild(document.createTextNode(`${addToCartText} - ${variantPrice}`));
        }

        // Update submit button
        this.submitButton.removeAttribute('disabled');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (this.submitButton.hasAttribute('disabled')) return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/javascript',
          },
        };

        const formData = new FormData(this.form);
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (cart) {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${window.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error('Error adding to cart:', response);
              return;
            }

            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // Close the mobile layer BEFORE updating cart
            this.close();

            if (typeof publish !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'variant-selector-layer-mobile',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }

            // Small delay to ensure layer is closed before cart opens
            setTimeout(() => {
              cart.renderContents(response);
            }, 100);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
          });
      }
    }
  );
}
